import PropTypes from "prop-types";
import React from "react";
import CustomInput from "../../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../../components/CustomForm/CustomSelect";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup
} from "../../../../components/CustomForm/FormStyles";
import Colors from "../../../../themes/Colors";
import { ESTADOS_PRECERTIFICACION } from "../../constantes";

const ConsultarPrecertificacionesForm = ({
  fechaDesde,
  fechaHasta,
  numeroSolicitud,
  numeroPlastico,
  estatus,
  onStateChange,
  onSearch,
  isLoading
}) => {
  const estatusOptions = Object.values(ESTADOS_PRECERTIFICACION).map(
    (estado) => ({
      label: estado.texto,
      value: estado.valor
    })
  );

  return (
    <FormWrapper borderColor={Colors.transparent}>
      <Form justifyContent={"space-between"} flexDirection={"column"}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            gap: "2px"
          }}
        >
          <FormGroup width={"30%"}>
            <CustomInput
              type={"date"}
              label={"Fecha desde"}
              isLabelWithContainer={true}
              value={fechaDesde}
              onChange={onStateChange("fechaDesde")}
            />
          </FormGroup>
          <FormGroup width={"30%"}>
            <CustomInput
              type={"date"}
              label={"Fecha hasta"}
              isLabelWithContainer={true}
              value={fechaHasta}
              onChange={onStateChange("fechaHasta")}
            />
          </FormGroup>
          <FormGroup width={"30%"}>
            <CustomInput
              type={"text"}
              placeholder={"No. solicitud"}
              label={"No. solicitud"}
              isLabelWithContainer={true}
              value={numeroSolicitud}
              onChange={onStateChange("numeroSolicitud")}
            />
          </FormGroup>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            gap: "2px"
          }}
        >
          <FormGroup width={"30%"}>
            <CustomInput
              type={"number"}
              placeholder={"No. de Afiliado/Carnet"}
              label={"Afiliado"}
              isLabelWithContainer={true}
              value={numeroPlastico}
              onChange={onStateChange("numeroPlastico")}
            />
          </FormGroup>
          <FormGroup width={"30%"}>
            <CustomSelect
              label={"Estatus"}
              isLabelWithContainer={true}
              options={estatusOptions}
              value={estatus}
              onChange={onStateChange("estatus")}
            />
          </FormGroup>
          <FormGroup width={"30%"}>
            <CustomButton
              label={"Buscar"}
              onClick={onSearch}
              isLoading={isLoading}
              height={"46px"}
              width={"120px"}
            />
          </FormGroup>
        </div>
      </Form>
    </FormWrapper>
  );
};

ConsultarPrecertificacionesForm.propTypes = {
  fechaDesde: PropTypes.string,
  fechaHasta: PropTypes.string,
  numeroSolicitud: PropTypes.string,
  numeroPlastico: PropTypes.string,
  estatus: PropTypes.string.isRequired,
  onStateChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export default ConsultarPrecertificacionesForm;
